import React from 'react';
import { MantineProvider, createTheme } from '@mantine/core';
import LandingPage from './LandingPage';
import '@mantine/core/styles.css'; // Обязательный импорт стилей Mantine

// Создаем кастомную тему с цветами вашего бренда
const theme = createTheme({
  colors: {
    grayTurquoise: [
      '#eef3f2', '#d8e3e1', '#b3c9c5', '#8dafaa', '#6f9991',
      '#5c8b82', '#50847b', '#426f6a', '#39635e', '#2e5651'
    ],
    lightYellow: [
      '#ffffff', '#fefef2', '#fcfce4', '#f8f8d5', '#f6f6c7',
      '#f4f4db', '#f3f3d3', '#dcdcc4', '#c5c5b0', '#afaf9b'
    ],
    salmon: [
      '#ffecea', '#ffd8d1', '#ffb3a1', '#ff8c6e', '#ff754a',
      '#ff753a', '#ff751f', '#e66516', '#cc5911', '#b34c0b'
    ],
  },
  primaryColor: 'grayTurquoise', // Установим основной цвет
});

function App() {
  return (
    <MantineProvider theme={theme}>
      <LandingPage />
    </MantineProvider>
  );
}

export default App;
